"use strict";

var Reflux = require("reflux");
var usersAPI = require("app/util/api/users");

var UserSelectFilterActions = Reflux.createActions({
    "loadUsers": {children: ["completed","failed"]},
    "populate": { sync: true }
});

UserSelectFilterActions.loadUsers.listen(function(){
  usersAPI.get({}, function(users){
    this.completed(users);
  }.bind(this));
});

module.exports = UserSelectFilterActions;



// WEBPACK FOOTER //
// ./app/screens/Activity/actions/user-select-filter-actions.js